import React from 'react'
import { connect } from 'react-redux'
import { withTranslation, useTranslation } from 'react-i18next'
import { capitalize } from 'srcReact/helpers/utils'
import styles from './styles.module.scss'
import InterestPicker from 'srcReact/components/common2/InterestPicker'

const Interest = (props) => {
  const { t } = useTranslation()
  const { isMobile, selectedInterests, setSuccess, goToPreviousStep, formState, setFormState, setNewAccountDatas } =
    props

  const formatBirthDate = () => {
    let {
      dayBirth,
      monthBirth: { value: monthBirth },
      yearBirth
    } = formState

    dayBirth = dayBirth < 10 ? `0${dayBirth}` : dayBirth
    monthBirth = monthBirth < 10 ? `0${monthBirth}` : monthBirth

    return `${yearBirth}-${monthBirth}-${dayBirth}`
  }

  const interestsToString = () => selectedInterests.map((e) => e.id).join(',')

  const handleConfirm = () => {
    setFormState({
      ...formState,
      selectedInterests: selectedInterests
    })

    setNewAccountDatas({
      email: formState.email,
      password: formState.fromSSO === 1 ? '' : formState.password,
      fromSSO: formState.fromSSO === 1 ? 1 : 0,
      firstname: formState.firstName,
      lastname: formState.lastName,
      ...(formState.preferred_pronoun && formState.preferred_pronoun.value
        ? { preferred_pronoun: formState.preferred_pronoun.value }
        : {}),
      personalized_pronoun: formState.personalized_pronoun[0]
        ? `${capitalize(formState.personalized_pronoun[0])}/${capitalize(formState.personalized_pronoun[1])}`
        : '',
      picture_id: formState.profilePictureId,
      is_public: formState.is_public ? 1 : 0,
      gender: formState.gender.value,
      birthday: formatBirthDate(),
      interest_ids: interestsToString(),
      workplace_ids: formState.workplaceInvitationsSelected,
      organization_id: formState.orgId,
      apiSubdomain: formState.apiSubDomain
    })

    setSuccess(true)
  }
  return (
    <div className={styles.container}>
      <InterestPicker
        origin='registration'
        userEmail={formState?.email}
        isMobile={isMobile}
        isLoggedIn={0}
        minInterestsCount={3}
        existingInterests={formState.selectedInterests}
        primaryButton={{ text: t('signup.interest_module.confirm'), size: 'large', clickHandler: handleConfirm }}
        secondaryButton={{ text: t('signup.interest_module.back'), size: 'large', clickHandler: goToPreviousStep }}
      />
    </div>
  )
}

function mapStateToProps(state) {
  const {
    common: {
      isMobile,
      interests: { list, stats },
      interestsSearchLoading,
      suggestedInterest,
      suggestInterestLoading,
      selectedInterests
    }
  } = state
  return {
    isMobile,
    interestsSearchLoading,
    list,
    stats,
    suggestedInterest,
    suggestInterestLoading,
    selectedInterests
  }
}

const ExtendedComponent = withTranslation('common')(Interest)

const connectedInterest = connect(mapStateToProps, null)(ExtendedComponent)
export { connectedInterest as Interest }
